import { metricsBus } from "buses";
import localMetrics from "services/localMetrics/localMetrics";

metricsBus.on("gifView", localMetrics.sendGifView);
metricsBus.on("gifPlayback", localMetrics.sendGifPlayback);
